module.exports = __webpack_public_path__ + "static/media/20170806_26day_1351AT.26d19356.jpg";